<template>
  <div class="services">
    <menuBox :step="3"></menuBox>
    <div class="services-box">
      Berkonsultasi
    </div>
    <div class="team-box">
      <div class="team-title">Nasihat Keuangan</div>
      <div class="team-line"></div>
      <div class="team-text">Pahami tren industri terkini untuk membantu Anda mengambil keputusan</div>
      <div class="team-list">
        <div class="list">
          <img src="../assets/number1.png" alt="">
          <div>
            <p>Revolusi Digital</p>
            <span>Fintech terus mengedepankan inovasi dan optimalisasi layanan.</span>
          </div>
        </div>
        <div class="list">
          <img src="../assets/number2.png" alt="">
          <div>
            <p>Keuangan Hijau</p>
            <span>Meningkatkan kesadaran lingkungan dan mendorong pertumbuhan investasi berkelanjutan.</span>
          </div>
        </div>
        <div class="list">
          <img src="../assets/number3.png" alt="">
          <div>
            <p>Penyesuaian Kebijakan</p>
            <span>Pengawasan keuangan global telah diperkuat untuk menghadapi fluktuasi pasar.</span>
          </div>
        </div>
      </div>
    </div>
    <div class="entrepreneurs">
      <div class="content">
        <p>Membantu Anda memahami tren perubahan industri dan menemukan investasi terbaik untuk Anda</p>
        <div class="btn" @click="step">Hubungi kami</div>
      </div>
    </div>
    <div class="testimonial">
      <div class="testimonial-left">
        <div class="bt">Belajarlah lagi</div>
        <div class="lineBox"></div>
        <img src="../assets/testimonial.png" alt="">
        <div class="title">2024</div>
        <div class="text">Bagaimana menjaga kekayaan di tengah krisis ekonomi global</div>
      </div>
      <div class="testimonial-right">
        <div class="bt">Bidang Profesional</div>
        <div class="lineBox"></div>
        <div class="info">
          <img src="../assets/people.png" alt="">
          <div>
            <p>Simon</p>
            <span>Analis data</span>
          </div>
        </div>
        <div class="title">Diversifikasikan investasi Anda dan fokus pada emas dan obligasi; tingkatkan likuiditas dan
          kurangi leverage; perhatikan nilai investasi jangka panjang.</div>
        <img class="group" src="../assets/group.png" alt="">
      </div>
    </div>
    <footerBox :step="3"></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      val: ''
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "Contact" });
    },
  },
};
</script>
<style lang="less" scoped>
.services-box {
  width: 100%;
  height: 200px;
  padding: 0 360px;
  line-height: 200px;
  background: #413F42;
  position: relative;
  box-sizing: border-box;
  font-family: Roboto, Roboto;
  font-weight: 500;
  font-size: 48px;
  color: #FFFFFF;
}

.team-box {
  padding: 120px 360px;
  font-family: Roboto, Roboto;
  text-align: center;

  .team-title {
    margin-bottom: 30px;
    font-weight: 500;
    font-size: 46px;
    color: #333333;
  }

  .team-line {
    margin: 0 auto 20px;
    width: 80px;
    height: 8px;
    background: #CF9555;
  }

  .team-text {
    margin-bottom: 60px;
    font-size: 19px;
    color: #999999;
  }

  .team-list {
    display: flex;
    font-family: Roboto, Roboto;
    text-align: left;

    .list {
      width: 33%;
      margin-right: 25px;

      div {
        padding: 16px 0;
      }
    }

    .list:nth-child(4) {
      margin-right: 0;
    }

    img {
      vertical-align: bottom;
      width: 383px;
      height: 260px;
    }

    p {
      margin-bottom: 4px;
      font-weight: 600;
      font-size: 24px;
      line-height: 36px;
      color: #333333;
    }

    span {
      font-size: 18px;
      color: #999999;
    }
  }
}

.entrepreneurs {
  background-image: url(../assets/entrepreneurs.png);
  width: 100%;
  height: 335px;
  padding-top: 100px;
  background-size: 100% 100%;

  .content {
    max-width: 664px;
    margin: 0 auto;
    text-align: center;

    p {
      margin-bottom: 54px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 36px;
      color: #FFFFFF;
      line-height: 43px;

      span {
        color: #CF9555;
      }
    }

    .btn {
      cursor: pointer;
      margin: 0 auto;
      display: inline-block;
      padding: 20px 40px;
      background: #CF9555;
      font-size: 28px;
      color: #FFFFFF;
    }
  }
}

.testimonial {
  padding: 120px 360px;
  display: flex;
  justify-content: space-between;

  .testimonial-left {
    max-width: 309px;
    font-family: Roboto, Roboto;

    .bt {
      margin-bottom: 25px;
      font-weight: 500;
      font-size: 46px;
      color: #333333;
      line-height: 55px;
    }

    .lineBox {
      margin-bottom: 80px;
      width: 59px;
      height: 8px;
      background: #CF9555;
    }

    img {
      width: 309px;
      height: 209px;
    }

    .title {
      margin-bottom: 10px;
      font-size: 20px;
      color: #999999;
      line-height: 30px;
    }

    .text {
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 36px;
    }
  }

  .testimonial-right {
    max-width: 665px;

    .bt {
      margin-bottom: 25px;
      font-weight: 500;
      font-size: 46px;
      color: #333333;
      line-height: 55px;
    }

    .lineBox {
      margin-bottom: 80px;
      width: 59px;
      height: 8px;
      background: #CF9555;
    }

    .info {
      display: flex;
      align-items: center;
      padding-bottom: 40px;
      margin-bottom: 34px;
      border-bottom: 1px solid rgba(153, 153, 153, 0.6);

      img {
        margin-right: 22px;
        width: 128px;
        height: 128px;
      }

      p {
        font-weight: 500;
        font-size: 24px;
        color: #333333;
        line-height: 36px;
      }

      span {
        font-size: 20px;
        color: #CF9555;
        line-height: 30px;
      }
    }

    .title {
      margin-bottom: 30px;
      font-size: 22px;
      color: #999999;
      line-height: 33px;
    }

    .group {
      width: 47px;
      height: 8px;
    }
  }
}
</style>
